import type { IUserKeywordGroup } from "app/services/keyword-groups";
import type { IAccountUser } from "app/sharing/SharingService";

import type {
    IKeywordGroup,
    ISharedKeywordGroup,
} from "app/common/keyword-research/monitor-lists/monitorKeywordsTypes";

export const getSharedGroupsWithOwnerName = (
    sharedGroups: IKeywordGroup[],
    users: IAccountUser[],
): ISharedKeywordGroup[] => {
    return sharedGroups.map((group) => {
        const groupIdAsNumber = parseInt(group.UserId);
        const groupOwner = users.find((user) => user.Id === groupIdAsNumber);

        return { ...group, sharedBy: `${groupOwner?.User}`, isShared: true };
    });
};

export const removeOwnerGroupsFromSharedGroups = (
    sharedGroups: IUserKeywordGroup[],
    userGroups: IUserKeywordGroup[],
) => {
    const userGroupIds = new Set(userGroups.map((g) => g.Id));
    return sharedGroups.filter((g) => !userGroupIds.has(g.Id));
};
